import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

export function getRouteParamAsNumber(
  route: ActivatedRoute,
  paramName: string
): Observable<number> {
  return route.paramMap.pipe(
    map((params) => params.get(paramName)),
    filter((id): id is string => !!id),
    map(Number),
    filter((id) => !isNaN(id))
  );
}
